var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCategoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.7085 6.1665C9.7085 5.82133 9.98832 5.5415 10.3335 5.5415H20.3335C20.6787 5.5415 20.9585 5.82133 20.9585 6.1665C20.9585 6.51168 20.6787 6.7915 20.3335 6.7915H10.3335C9.98832 6.7915 9.7085 6.51168 9.7085 6.1665Z",
    fill: "#212121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.7085 12C9.7085 11.6548 9.98832 11.375 10.3335 11.375H20.3335C20.6787 11.375 20.9585 11.6548 20.9585 12C20.9585 12.3452 20.6787 12.625 20.3335 12.625H10.3335C9.98832 12.625 9.7085 12.3452 9.7085 12Z",
    fill: "#212121"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.7085 17.8335C9.7085 17.4883 9.98832 17.2085 10.3335 17.2085H20.3335C20.6787 17.2085 20.9585 17.4883 20.9585 17.8335C20.9585 18.1787 20.6787 18.4585 20.3335 18.4585H10.3335C9.98832 18.4585 9.7085 18.1787 9.7085 17.8335Z",
    fill: "#212121"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33317 10.9585C4.75787 10.9585 4.2915 11.4249 4.2915 12.0002C4.2915 12.5755 4.75787 13.0418 5.33317 13.0418C5.90847 13.0418 6.37484 12.5755 6.37484 12.0002C6.37484 11.4249 5.90847 10.9585 5.33317 10.9585ZM3.0415 12.0002C3.0415 10.7345 4.06752 9.7085 5.33317 9.7085C6.59882 9.7085 7.62484 10.7345 7.62484 12.0002C7.62484 13.2658 6.59882 14.2918 5.33317 14.2918C4.06752 14.2918 3.0415 13.2658 3.0415 12.0002Z",
    fill: "#212121"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33317 16.7915C4.75787 16.7915 4.2915 17.2579 4.2915 17.8332C4.2915 18.4085 4.75787 18.8748 5.33317 18.8748C5.90847 18.8748 6.37484 18.4085 6.37484 17.8332C6.37484 17.2579 5.90847 16.7915 5.33317 16.7915ZM3.0415 17.8332C3.0415 16.5675 4.06752 15.5415 5.33317 15.5415C6.59882 15.5415 7.62484 16.5675 7.62484 17.8332C7.62484 19.0988 6.59882 20.1248 5.33317 20.1248C4.06752 20.1248 3.0415 19.0988 3.0415 17.8332Z",
    fill: "#212121"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.85845 4.47456C8.10252 4.71864 8.10252 5.11437 7.85845 5.35845L5.35845 7.85845C5.11437 8.10252 4.71864 8.10252 4.47456 7.85845L3.22456 6.60845C2.98048 6.36437 2.98048 5.96864 3.22456 5.72456C3.46864 5.48048 3.86437 5.48048 4.10845 5.72456L4.9165 6.53262L6.97456 4.47456C7.21864 4.23048 7.61437 4.23048 7.85845 4.47456Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryIcon);
export default __webpack_public_path__ + "static/media/category-icon.550830dff875ec47d7fdf27fad9bb2ab.svg";
export { ForwardRef as ReactComponent };